import { RouteObject } from 'react-router';

import { RecommendationsContainer } from './containers/RecommendationsContainer';
import { RecommendationsCreateContainer } from './containers/RecommendationsCreateContainer';
import { RecommendationsHistoryContainer } from './containers/RecommendationsHistoryContainer';
import { RecommendationsEditContainer } from './containers/RecommendationsEditContainer';

const routes: RouteObject[] = [
    {
        path: 'recommendations',
        element: <RecommendationsContainer />,
        children: [
            {
                path: 'create',
                element: <RecommendationsCreateContainer />,
            },
            {
                path: 'edit',
                element: <RecommendationsEditContainer />,
            },
            {
                path: `history`,
                element: <RecommendationsHistoryContainer />,
            },
        ],
    },
];

export default routes;
